import {
    Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { documentLogs } from '../../graphql/queries';
import { generateClient } from 'aws-amplify/api';
import MaterialTable from '@material-table/core';
import moment from 'moment';
import { ChangeCircleOutlined, PublishedWithChangesOutlined, UnpublishedOutlined } from '@mui/icons-material';

export function HistoryDialog(props) {
	const client = generateClient();
	const [open, setOpen] = useState(props.open);
	const [fetchingLogs, setFetchingLogs] = useState(false);
	const [logs, setLogs] = useState([]);

	useEffect(() => {
		if (props.document) {
			getDocumentLogs();
		}
	}, [props.document]);

	useEffect(() => {
		setOpen(props.open);
	}, [props.open]);

	async function getDocumentLogs() {
		setFetchingLogs(true);
		try {
			const items = [];
			let nextToken;
			do {
				const response = await client.graphql({
					query: documentLogs,
					variables: {
						documentId: props.document.documentId,
						sortDirection: 'DESC',
					},
				});
				nextToken = response.data.documentLogs.nextToken;
				items.push(...response.data.documentLogs.items);
			} while (nextToken);
			setLogs(items);
		} catch (e) {
			console.error('Error getting logs', e);
		}
		setFetchingLogs(false);
	}

	function handleClose() {
		setOpen(false);
		props.onClose();
	}

	return (
		<Dialog maxWidth="lg" open={open}>
			<DialogTitle>{props?.document?.name} history</DialogTitle>
			<DialogContent>
				<Grid container direction="column">
					<MaterialTable
                        title="Changes"
						data={logs}
						isLoading={fetchingLogs}
						options={{
							pageSize: 10,
							searchText: window.sessionStorage.getItem(
								'DocumentAuditLogSearch',
							),
						}}
						columns={[
							{
								title: 'Timestamp',
								field: 'timestamp',
								width: '275px',
								render: (rowData) => (
									<Box display="flex">
										{moment(rowData.timestamp).format('L LT')}
									</Box>
								),
							},
							{
								title: 'Action',
								field: 'action',
								width: '150px',
								render: (rowData) => (
									<Box display="flex" alignItems="center">
										{rowData.action === 'CREATED' && (
											<Box
												display="flex"
												alignItems="center"
												gap={1}
											>
												<PublishedWithChangesOutlined
													color="success"
													fontSize="small"
												/>
												Created
											</Box>
										)}
										{rowData.action === 'UPDATED' && (
											<Box
												display="flex"
												alignItems="center"
												gap={1}
											>
												<ChangeCircleOutlined
													color="primary"
													fontSize="small"
												/>
												Updated
											</Box>
										)}
										{rowData.action === 'DELETED' && (
											<Box
												display="flex"
												alignItems="center"
												gap={1}
											>
												<UnpublishedOutlined
													color="error"
													fontSize="small"
												/>
												Deleted
											</Box>
										)}
									</Box>
								),
							},
							{
								title: 'Document',
								field: 'documentId',
								render: (rowData) => (
									<Box display="flex">
										<>
											{!rowData.deleted && (
												<>
													{rowData.type === 'Segment' && (
														<Button
															variant="text"
															onClick={() => {
																navigate(
																	`/segments/${rowData.documentId}?op=edit`,
																);
															}}
														>
															{rowData.name ? rowData.name : rowData.documentId}
														</Button>
													)}
													{rowData.type === 'Suppression' && (
														<Button
															variant="text"
															onClick={() => {
																navigate(`/suppression/${rowData.documentId}`);
															}}
														>
															{rowData.name ? rowData.name : rowData.documentId}
														</Button>
													)}
													{rowData.type === 'Profile' && (
														<Button
															variant="text"
															onClick={() => {
																navigate(`/profiles/${rowData.documentId}`);
															}}
														>
															{rowData.name ? rowData.name : rowData.documentId}
														</Button>
													)}
													{rowData.type === 'ManualProfile' && (
														<Button
															variant="text"
															onClick={() => {
																navigate(
																	`/manual-profiles/${rowData.documentId}`,
																);
															}}
														>
															{rowData.name ? rowData.name : rowData.documentId}
														</Button>
													)}
													{rowData.type === 'Campaign' && (rowData.name ? rowData.name : rowData.documentId)}
												</>
											)}
											{rowData.deleted ? (rowData.name ? rowData.name : rowData.documentId) : ''}
										</>
									</Box>
								),
							},
							{ title: 'User Name', field: 'userName' },
							
						]}
					></MaterialTable>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
}
